import React from 'react';
import { FadeIn } from '../ui/FadeIn';
import { Button } from '../ui/Button';
import { Lock } from 'lucide-react';
export function OfferSection() {
  return <section id="offer-section" className="py-24 px-4 bg-dark-900 relative overflow-hidden" data-id="element-90">
      {/* Background glow */}
      <div className="absolute bottom-0 left-1/2 -translate-x-1/2 translate-y-1/2 w-[800px] h-[800px] bg-gold/10 rounded-full blur-[120px] pointer-events-none" data-id="element-91" />

      <div className="max-w-5xl mx-auto relative z-10" data-id="element-92">
        <div className="grid lg:grid-cols-2 gap-12 items-center bg-dark-800/80 border border-gold/20 rounded-2xl p-8 md:p-12 backdrop-blur-sm" data-id="element-93">
          <FadeIn className="order-2 lg:order-1" data-id="element-94">
            <div className="text-center lg:text-left" data-id="element-95">
              <h2 className="text-3xl md:text-4xl mb-6" data-id="element-96">
                Tu paz mental no tiene precio
              </h2>
              <p className="text-lg text-offwhite/80 font-light mb-8 leading-relaxed" data-id="element-97">
                Pero hoy puedes acceder al sistema completo "El Espejo Roto" por
                una fracción de lo que costaría una sola sesión de terapia
                especializada.
              </p>

              <div className="mb-8" data-id="element-98">
                <span className="text-sm text-offwhite/50 uppercase tracking-widest block mb-2" data-id="element-99">
                  Inversión Única
                </span>
                <span className="text-5xl md:text-6xl font-serif text-gold" data-id="element-100">
                  $297 <span className="text-2xl text-gold/70" data-id="element-101">USD</span>
                </span>
              </div>

              <Button className="w-full mb-4 py-5 text-xl" data-id="element-102">
                RECLAMA TU IDENTIDAD AHORA
              </Button>

              <div className="flex items-center justify-center lg:justify-start gap-2 text-sm text-offwhite/50 mt-4" data-id="element-103">
                <Lock className="w-4 h-4" data-id="element-104" />
                <span data-id="element-105">Pago 100% seguro y discreto. Acceso inmediato.</span>
              </div>
            </div>
          </FadeIn>

          <FadeIn delay={0.2} className="order-1 lg:order-2 flex justify-center" data-id="element-106">
            <img src="https://cdn.magicpatterns.com/uploads/1rjF1Jk5DwbZxcJKxYhxCt/EL_ESPEJO_ROTO2.png" alt="El Espejo Roto" className="w-full max-w-sm h-auto object-contain drop-shadow-[0_0_30px_rgba(212,175,55,0.2)]" data-id="element-107" />
          </FadeIn>
        </div>
      </div>
    </section>;
}